module.exports = "/images/vendor/vue2vis/dist/connectIcon.png?d5267b8db2498e44bd567bd12e07576b";